/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useRef, useState } from 'react'

/** Utilities */
import { getDropdownValue } from '../../../../../../components/finalForms/libs/data/dropdownUtilities';
/** Contexts */
import { ServiceLocationContext } from '../../../../../../utils/context/ServiceLocationContext';

/** Common Components */
import ToastService from '../../../../../../services/toastService/ToastService';
import FormCreator from '../../../../../../components/finalForms/FormCreator';
import Buttons from '../../../../../../components/ui/button/Buttons';
import SwalAlert from '../../../../../../services/swalService/SwalService';

/** Configuration files */
import { FieldSettingType } from '../../../../../../components/finalForms/libs/data/fieldSettingType';
import { setDropdownOptions } from '../../../../../../components/finalForms/libs/data/mapDropdownOptions';
import { setFieldSetting } from '../../../../../../utils/formFieldUtils/ManageFields';
import { ContractsConfig } from './Contract.formfield.config';

/** RTK Query */
import { useGetAllContractsListMutation, useLazyGetAllContractInstallmentTypesQuery } from '../../../../../../app/services/contractAPI';
import { useLazyGetPendingContractScopesQuery, usePendingContractConvertToContractMutation } from '../../../../../../app/services/pendingContractAPI';
import PropTypes from 'prop-types';

const Contract = ({ onClose, onSuccess, pendingContractData }) => {

    const { error, confirm } = SwalAlert();
    const Contractref = useRef();
    const [pendingContractForm, setPendingContractForm] = useState(ContractsConfig);

    const { selectedLocation } = useContext(ServiceLocationContext);
    const locationkey = getDropdownValue(selectedLocation);


    const [getAllContractInstallmentTypes, {
        isFetching: isAllContractInstallmentTypesFetching,
        isSuccess: isAllContractInstallmentTypesFetched,
        data: allContractInstallmentTypesData,
    },] = useLazyGetAllContractInstallmentTypesQuery();

    const [pendingContractConvertToContract, {
        isSuccess: ispendingContractConvertToContractAdded,
        data: pendingContractConvertToContractData,
    },] = usePendingContractConvertToContractMutation();

    const [getAllContractsList] = useGetAllContractsListMutation();

    const [getPendingContractScopes] = useLazyGetPendingContractScopesQuery();

    useEffect(() => {
        if (locationkey) {
            getAllContractInstallmentTypes(false);
            setFieldSetting(pendingContractForm, 'lInstallmentTypeID', FieldSettingType.ISFIELDDATALOADING, true);
        }
    }, [locationkey])

    useEffect(() => {
        if (pendingContractData) {
            let formData = { ...pendingContractForm };
            formData.initialState = {
                ...pendingContractForm.initialState,
                sPendingContractName1: pendingContractData?.sPendingContractName1,
                sContractType: pendingContractData?.sContractType,
                sClientName1: pendingContractData?.sClientName1,
                lInstallmentTypeID: 1,
                contractlength: 12,
            }
            setPendingContractForm(formData);
            handleInputChange(null, formData.initialState);
        }
    }, [pendingContractData])


    useEffect(() => {
        if (!isAllContractInstallmentTypesFetching && isAllContractInstallmentTypesFetched && allContractInstallmentTypesData) {
            setDropdownOptions(allContractInstallmentTypesData, 'lInstallmentTypeID', 'sInstallmentType', pendingContractForm, 'lInstallmentTypeID', setPendingContractForm);
            setFieldSetting(pendingContractForm, 'lInstallmentTypeID', FieldSettingType.ISFIELDDATALOADING, false);
        }
    }, [isAllContractInstallmentTypesFetching, isAllContractInstallmentTypesFetched, allContractInstallmentTypesData])

    useEffect(() => {
        if (ispendingContractConvertToContractAdded && pendingContractConvertToContractData) {
            if (pendingContractConvertToContractData) {
                ToastService.success(pendingContractConvertToContractData?.errorMessage);
                resetForm();
                onSuccess();
            }
        }
    }, [ispendingContractConvertToContractAdded, pendingContractConvertToContractData]);


    const handleInputChange = (dataField, updatedFormData) => {
        const { sClientName1, sContractType, Dterminationdate, contractlength, EffectiveDate } = updatedFormData;
        let newTerminationDate = Dterminationdate;

        if (EffectiveDate && contractlength && contractlength > 0) {
            const effectiveDate = new Date(EffectiveDate);
            newTerminationDate = new Date(effectiveDate);
            newTerminationDate.setMonth(effectiveDate.getMonth() + Number(contractlength));
            newTerminationDate.setDate(newTerminationDate.getDate() - 1);
        }
        const newFormData = {
            ...pendingContractForm,
            initialState: {
                ...updatedFormData,
                Dterminationdate: newTerminationDate,
            },
        }
        if (sClientName1 && sContractType && newTerminationDate) {
            newFormData.initialState.sPendingContractName1 = `${sClientName1 || ''} - ${sContractType || ''} - ${new Date(newTerminationDate).toLocaleDateString()}`;
        }
        setPendingContractForm(newFormData);
    };

    const handleFieldChange = (dataField, updatedData) => {
        if (dataField === 'Dterminationdate') {
            handleInputChange(dataField, updatedData);
        }
        else if (dataField === 'contractlength' || dataField === 'EffectiveDate') {
            handleInputChange(dataField, updatedData);
        }
    }

    const resetForm = () => {
        const formData = { ...pendingContractForm };
        formData.initialState = { ...pendingContractForm.initialState };
        setPendingContractForm(formData);
    }

    const handleSaveClick = async () => {
        if (!Contractref.current) return;

        const formData = Contractref.current.getFormData();
        if (!formData) return;

        const contractlength = formData?.contractlength;
        if (!contractlength || contractlength <= 0) {
            ToastService.warning('Please enter valid Contract Length');
            return;
        }

        const requestData = {
            plPendingContractKey: pendingContractData?.lPendingContractKey,
            plClientKey: pendingContractData?.lClientKey,
            plContractTypeKey: pendingContractData?.lContractTypeKey,
            plInstallmentTypeID: getDropdownValue(formData?.lInstallmentTypeID),
            pdtDateEffective: formData?.EffectiveDate,
            pdtDateTermination: formData?.Dterminationdate,
            psContractNumber: formData?.PurchaseOrderNumber,
            plContractLength: contractlength,
            psContractName: formData?.sPendingContractName1?.trim(),
        };

        const nameReq = {
            psContractName: requestData.psContractName,
            pbIncludeInactive: true,
            pbIncludeAll: false,
            plClientKey: 0,
        };

        const nameRes = await getAllContractsList(nameReq);
        if (nameRes?.data?.totalRecord > 0) {
            error(
                "This Contract Name already exists and cannot be reused.",
                "Invalid Contract Name"
            );
            return;
        }

        const scopeRes = await getPendingContractScopes(requestData.plPendingContractKey);
        const scopes = scopeRes?.data || [];

        if (scopes.length === 0) {
            const result = await confirm(
                "You haven't added any scopes to this pending contract.",
                "Are you sure you want to convert it to a real contract?",
                "Yes",
                "Cancel"
            );
            if (!result) return;
        }
        else {

            const invalidScopes = scopes.filter(s => s.lScopeKey === 0);

            if (invalidScopes.length > 0) {
                if (invalidScopes.length === 1) {
                    error(
                        "There is a scope without a serial number. Serial numbers are required before converting the pending contract.",
                        "Cannot Convert Contract"
                    );
                } else {
                    error(
                        "There are scopes without serial numbers. Serial numbers are required before converting the pending contract.",
                        "Cannot Convert Contract"
                    );
                }
                return;
            }
        }
        await pendingContractConvertToContract(requestData);
    };

    return (
        <>
            <FormCreator
                ref={Contractref}
                config={pendingContractForm}
                onColumnChange={handleFieldChange}
            />
            <div className="d-flex justify-content-center button-submit">
                <Buttons
                    buttonText="Save"
                    buttonTypeClassName="btn blue-btn w-full"
                    onClick={handleSaveClick}
                />
                <Buttons
                    buttonText="Cancel"
                    buttonTypeClassName="btn secondary-btn ml-4"
                    onClick={onClose}
                />
            </div>
        </>
    )
}

Contract.propTypes = {
    onClose: PropTypes.func,
    onSuccess: PropTypes.func,
    pendingContractData: PropTypes.shape({
        sPendingContractName1: PropTypes.string,
        sContractType: PropTypes.string,
        sClientName1: PropTypes.string,
        lPendingContractKey: PropTypes.number,
        lClientKey: PropTypes.number,
        lContractTypeKey: PropTypes.number,
    }),
};

export default Contract;
